 <template>
   
    <section class="theme-bg-yellow " id="products" >
        <div class="container text-center">
            <div class="row text-center" style="align-items: center;
        justify-content: center;
        margin-bottom: -30px;
        margin-top: 60px;
">
                 <div class="row">
              <div class="col-12 text-center" style="margin-bottom:20px;">
               <h2 class="text-green" >กยท. ก้าวไกล</h2>
               <h2 class="text-green"> ศูนย์กลางผลิตภัณฑ์ยางพาราคุณภาพดี</h2>
                <img :src='"../assets/images/green-line.png"' alt="/title-line">
              </div>
           </div>
                <div class="col-md-12 text-center">
                   <carousel   v-bind:class='"news-slider"'
                    :margin=30
                    :loop=true
                    :items=1
                    :nav=false
                    :dots=true
                    :dotsEach=true
                    :autoplay=true
                    :responsive="{0:{items:1},768:{items:1},1024:{items:1},1200:{items:1}}"
          >
         <div class="item ">
        
            <div class="row">
          <div class="col-md-12 col-sm-12 text-center">
           <div>
            
                <img src="../assets/images/product3_l.jpg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
       
          </div>
           
          </div>
        <div class="item ">
        
            <div class="row">
          <div class="col-md-12 col-sm-12 text-center">
           <div>
            
                <img src="../assets/images/product2_l.jpg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
       
          </div>
           
          </div>
         <div class="item ">
        
            <div class="row">
          <div class="col-md-12 col-sm-12 text-center">
           <div>
            
                <img src="../assets/images/product1_l.jpg" alt="news-1" class="img-fluid">
             
             
            </div>
          </div>
      
          </div>
           
          </div>

          </carousel>
                    </div>
                </div>
            </div>
      
    </section>
    <!--Package end -->
</template>
<script>
export default {
  name: 'Package'
}
</script> */
